import React, { useEffect, useState } from 'react'
import rawDataService from '../services/rawDataService'

export default function GlobalUploadBanner() {
  const [visible, setVisible] = useState(false)
  const [progress, setProgress] = useState<number | null>(null)
  const [filename, setFilename] = useState<string | null>(null)
  const [batchIndex, setBatchIndex] = useState<number | null>(null)
  const [batchTotal, setBatchTotal] = useState<number | null>(null)

  useEffect(() => {
    // 진행률 실시간 구독 (이벤트 값 그대로 반영)
    const unsubscribe = rawDataService.addProgressListener(({ progress, filename, batchIndex, batchTotal }) => {
      setProgress(progress)
      setFilename(filename)
      if (batchIndex != null) setBatchIndex(batchIndex)
      if (batchTotal != null) setBatchTotal(batchTotal)
    })
    const onStarted = () => {
      // 모달 열고 진행률 0으로 초기화 (새 업로드 시작)
      setVisible(true)
      setProgress(0)
      setFilename(null)
      setBatchIndex(null)
      setBatchTotal(null)
    }
    const onCompleted = () => {
      try {
        // 배치 기준으로 마지막 파일 완료인지 판단
        const totalRaw = localStorage.getItem('upload_batch_total')
        const indexRaw = localStorage.getItem('upload_batch_index')
        const totalNum = totalRaw ? Number(totalRaw) : null
        const indexNum = indexRaw ? Number(indexRaw) : null
        const hasBatchInfo = totalNum != null && indexNum != null && !Number.isNaN(totalNum) && !Number.isNaN(indexNum)
        const isLast = hasBatchInfo && indexNum >= totalNum
        // 단일 파일(배치정보 없음)은 즉시 닫기, 배치는 마지막 파일에서 닫기
        if (!hasBatchInfo || isLast || !rawDataService.getActiveSessionId()) {
          // 최종 완료로 간주: 모달 닫기 및 상태 초기화
          setVisible(false)
          setFilename(null)
          setProgress(null)
          setBatchTotal(null)
          setBatchIndex(null)
          try {
            localStorage.removeItem('upload_batch_total')
            localStorage.removeItem('upload_batch_index')
          } catch {}
        }
      } catch {
        // 안전하게 무시
        setVisible(false)
      }
    }
    window.addEventListener('upload:started', onStarted)
    window.addEventListener('upload:completed', onCompleted)
    // 폴링 제거: 이벤트 기반으로만 표시/숨김 처리
    return () => { unsubscribe(); window.removeEventListener('upload:started', onStarted); window.removeEventListener('upload:completed', onCompleted) }
  }, [])

  // ESC/배경 클릭 무시 + 스크롤 차단 (visible 상태에 따라 등록/해제)
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault()
        e.stopPropagation()
      }
    }
    const preventScroll = (e: Event) => { e.preventDefault() }

    if (visible) {
      document.addEventListener('keydown', onKeyDown, { capture: true })
      document.body.style.overflow = 'hidden'
      document.addEventListener('wheel', preventScroll, { passive: false })
      document.addEventListener('touchmove', preventScroll, { passive: false })
    }

    return () => {
      document.body.style.overflow = ''
      document.removeEventListener('keydown', onKeyDown as any, { capture: true } as any)
      document.removeEventListener('wheel', preventScroll as any)
      document.removeEventListener('touchmove', preventScroll as any)
    }
  }, [visible])

  if (!visible) return null

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-40" />
      {/* Modal */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white border border-gray-200 shadow-xl rounded-lg p-5">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-sm font-medium text-gray-900">파일 업로드 중</h3>
            <button
              onClick={async () => {
                try { await rawDataService.cancelCurrentUpload() } catch {}
                setVisible(false)
              }}
              className="text-xs px-2 py-1 border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-100"
            >취소</button>
          </div>
          {filename && (
            <div className="text-xs text-gray-600 mb-2 truncate" title={filename}>{filename}</div>
          )}
          {batchTotal && batchIndex != null && (
            <div className="text-xs text-gray-500 mb-1">{batchIndex}/{batchTotal}</div>
          )}
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-gray-800 h-2 rounded-full transition-all duration-300" style={{ width: `${progress ?? 0}%` }}></div>
          </div>
          <div className="mt-2 text-right text-xs text-gray-600">{progress ?? 0}%</div>
        </div>
      </div>
    </div>
  )
}


